import React from 'react';
import {DashboardLayout} from '@/components';
import { Outlet } from 'react-router-dom';
export const DashboardScreenLayout: React.FC = () => {
  return (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  );
};
